export interface BulletinEntry {
  id: string;
  date: string;
  title: string;
  kind: 'Data' | 'Feature' | 'Correction' | 'Method';
  summary: string;
  pages: Array<{ to: string; label: string }>;
}

// Newest first. Every data update to agentpopulation.com gets a dated entry here.
export const bulletin: BulletinEntry[] = [
  {
    id: 'b-2026-10-05-g',
    date: '2026-10-05',
    title: 'Builders, code, geography, trust grades and the agentpopulation.com rebrand',
    kind: 'Feature',
    summary:
      'Added the AI Builders dataset, the weekly GitHub code view, country filters on Models, a Country view and availability matrix on Platforms, A/B/C confidence grades with “Challenge this number” on every figure, staleness badges, CSV/JSON downloads, Parity, Compare, the embed widget and the API page. Agent Census is now published as agentpopulation.com.',
    pages: [
      { to: '/builders', label: 'Builders' },
      { to: '/code', label: 'Code' },
      { to: '/models', label: 'Models' },
      { to: '/platforms?tab=countries', label: 'Platforms · Country view' },
      { to: '/parity', label: 'Parity' },
      { to: '/compare?c=ind,usa,chn', label: 'Compare' },
      { to: '/api', label: 'API & data' },
    ],
  },
  {
    id: 'b-2026-10-05-f',
    date: '2026-10-05',
    title: 'Full-stack Platforms and new themes',
    kind: 'Data',
    summary: 'Platforms gained model platforms, compute providers and silicon tabs, each row sourced to vendor pages or filings. Added white and colourful themes.',
    pages: [{ to: '/platforms', label: 'Platforms' }],
  },
  {
    id: 'b-2026-10-05-e',
    date: '2026-10-05',
    title: 'Networks layer: APNIC aspop and Ookla speeds',
    kind: 'Data',
    summary: 'Country pages show their top networks live from APNIC (with a top-5 snapshot fallback) and an Ookla speed row. New global Networks page.',
    pages: [
      { to: '/networks', label: 'Networks' },
      { to: '/countries/IND', label: 'Country pages' },
    ],
  },
  {
    id: 'b-2026-10-05-d',
    date: '2026-10-05',
    title: 'India drawn with official boundaries',
    kind: 'Correction',
    summary: 'The world map now shows India with all of Jammu & Kashmir and Ladakh (including Aksai Chin) and Arunachal Pradesh, as on Survey of India maps.',
    pages: [{ to: '/map', label: 'World Map' }],
  },
  {
    id: 'b-2026-10-05-c',
    date: '2026-10-05',
    title: 'Shared scenario across every page',
    kind: 'Method',
    summary: 'The selected scenario now carries across pages and reloads, so country-level agent estimates always match the homepage gauge.',
    pages: [
      { to: '/', label: 'Census' },
      { to: '/countries', label: 'Countries' },
    ],
  },
  {
    id: 'b-2026-10-05-a',
    date: '2026-10-05',
    title: 'First census published',
    kind: 'Data',
    summary: 'Initial release: live human and machine counters, three scenarios, the population breakdown, the equal-area world map, country records, models, platforms, directories, discovery protocols and methodology.',
    pages: [
      { to: '/', label: 'Census' },
      { to: '/methodology', label: 'Methodology' },
    ],
  },
];
